// extracted by mini-css-extract-plugin
export default {"body":"Agreement_body__m5aY-"};